import { useCallback } from 'react'
import { shipmentsApi } from '../../../store/api/shipments-api'
import { useAppDispatch } from '../../../store/store'
import Shipment from '../../../types/api/shipment'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'

export function useUpdateQueryData(queryArg: EndpointQueryParameters) {
    const dispatch = useAppDispatch()

    return useCallback(
        (shipment: Shipment) => {
            const action = shipmentsApi.util.updateQueryData('getShipments', queryArg, draft => {
                const index = draft.data.findIndex(s => s.documentId === shipment.documentId)
                if (index !== -1) {
                    draft.data[index] = shipment
                }
            })

            dispatch(action)
        },
        [dispatch, queryArg]
    )
}
